import { LazyLoadImage } from "react-lazy-load-image-component";
import globalData from "@/i18n/json/global/data.json";
import JsxParser from "react-jsx-parser";
import { wrapper, locationItem, icon, strong } from "./styles";

const ContactLocations = () => {
    const details = globalData["contact-details"].locations;
    return (
        <div className={wrapper}>
            <div className={locationItem}>
                <LazyLoadImage className={icon} src="/assets/icons/contact/location.svg" />
                <div>
                    <strong className={strong}>{details.usa.heading}</strong>
                    <p>
                        <JsxParser renderInWrapper={false} jsx={details.usa.address} />
                    </p>
                </div>
            </div>
            <div className={locationItem}>
                <LazyLoadImage className={icon} src="/assets/icons/contact/location.svg" />
                <div>
                    <strong className={strong}>{details.rsa.heading}</strong>
                    <p>
                        <JsxParser renderInWrapper={false} jsx={details.rsa.address} />
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ContactLocations;
